'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _I18n = require('I18n');

var _I18n2 = _interopRequireDefault(_I18n);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  return _I18n2.default.locale !== 'en-us' && !_I18n2.default.langEnabled && !_I18n2.default.publicPage ? 'en-us' : _I18n2.default.locale;
};

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/I18n/static-7.297/js/utils/getLangLocale.js
// module id = 182
// module chunks = 0